// Dashboard 3 — Channel Performance. "What delivery vehicle works best?" — a
// comparison table across the channels that had traffic in the window.

import React from "react";
import { Skeleton } from "../../../ui/skeleton";
import { Panel } from "../../../Components/admin/reporting/controls";
import { getEngagementChannels } from "../../../Services/adminEngagement";
import {
  ChannelBadge,
  Rate,
  ErrorBox,
  EmptyState,
  WindowBadge,
  fmtInt,
  useEngagementData,
} from "./engagementShared";

const ChannelTab = ({ range }) => {
  const { data, loading, error } = useEngagementData(
    () => getEngagementChannels(range),
    [range]
  );

  const channels = data?.channels || {};
  const keys = Object.keys(channels);

  return (
    <div className="space-y-5">
      <WindowBadge window={data?.window} timezone={data?.timezone} />
      <Panel title="Channel comparison">
        {loading && !data ? (
          <div className="space-y-2">
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton key={i} className="h-10 w-full" />
            ))}
          </div>
        ) : error ? (
          <ErrorBox>{error}</ErrorBox>
        ) : keys.length === 0 ? (
          <EmptyState>No channel traffic in this window.</EmptyState>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b text-left text-xs text-muted-foreground">
                  <th className="py-2 pr-3 font-medium">Channel</th>
                  <th className="py-2 px-3 text-right font-medium">Messages sent</th>
                  <th className="py-2 px-3 text-right font-medium">Delivery</th>
                  <th className="py-2 px-3 text-right font-medium">Open</th>
                  <th className="py-2 px-3 text-right font-medium">Click</th>
                  <th className="py-2 px-3 text-right font-medium">Session start</th>
                  <th className="py-2 px-3 text-right font-medium">Conversion</th>
                </tr>
              </thead>
              <tbody>
                {keys.map((ch) => {
                  const c = channels[ch];
                  return (
                    <tr key={ch} className="border-b transition-colors hover:bg-slate-50">
                      <td className="py-2.5 pr-3 align-middle">
                        <ChannelBadge channel={ch} />
                      </td>
                      <td className="py-2.5 px-3 text-right align-middle font-semibold tabular-nums">
                        {fmtInt(c.messages_sent)}
                      </td>
                      <td className="py-2.5 px-3 text-right align-middle">
                        <Rate value={c.delivery_rate} available={c.delivery_rate_available} />
                      </td>
                      <td className="py-2.5 px-3 text-right align-middle">
                        <Rate value={c.open_rate} available={c.open_rate_available} hint="open" />
                      </td>
                      <td className="py-2.5 px-3 text-right align-middle">
                        <Rate value={c.click_rate} available={c.click_rate_available} hint="click" />
                      </td>
                      <td className="py-2.5 px-3 text-right align-middle">
                        <Rate
                          value={c.session_start_rate}
                          available={c.session_start_rate_available}
                        />
                      </td>
                      <td className="py-2.5 px-3 text-right align-middle font-semibold">
                        <Rate value={c.conversion_rate} available={c.conversion_rate_available} />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </Panel>
    </div>
  );
};

export default ChannelTab;
